import React, { CSSProperties, MutableRefObject, ReactElement } from 'react';
import classNames from 'classnames';
import styled from 'styled-components';
import { NormalMenuItemLinkSC } from './NormalMenu.styled';
import Icon from 'components/icon/Icon';

const MenuBadgeSC = styled.span`
    margin-left: auto;
    flex: 0 0 auto;
    min-width: 18px;
    padding: 1px 7px;
    border-radius: 999px;
    font-size: 10.5px;
    font-weight: 700;
    line-height: 1.6;
    text-align: center;
    background: rgba(255, 255, 255, 0.16);
    color: #fff;
`;

interface Props {
    text: string;
    title?: string;
    icon: React.FC<React.SVGProps<SVGSVGElement>>;
    active: boolean;
    link: string;
    justOnMobile?: boolean;
    forwardRef: MutableRefObject<HTMLDivElement>;
    iconStyle?: CSSProperties;
    badge?: number;
    badgeTitle?: string;
}

const NormalMenuItem = ({
    text,
    title,
    icon,
    active,
    link,
    justOnMobile,
    forwardRef,
    iconStyle,
    badge,
    badgeTitle,
}: Props): ReactElement => {
    const content = (
        <span title={title ?? text} ref={forwardRef}>
            <>
                {icon && (
                    <Icon icon={icon} style={iconStyle} className="icon" />
                )}
                {text}
            </>
        </span>
    );
    if (!link) {
        return (
            <span
                className={classNames('root', {
                    justOnMobile,
                    active,
                })}
            >
                {content}
            </span>
        );
    }
    return (
        <NormalMenuItemLinkSC
            className={classNames({
                justOnMobile,
                active,
            })}
            href={link}
            title={title ? title : undefined}
        >
            {content}
            {!!badge && badge > 0 && (
                <MenuBadgeSC title={badgeTitle}>{badge}</MenuBadgeSC>
            )}
        </NormalMenuItemLinkSC>
    );
};

export default NormalMenuItem;
